import {
  useState,
  createContext,
  useCallback,
  ReactNode,
  FC,
  useMemo,
} from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export const ToastContext = createContext({
  // eslint-disable-next-line
  addSnack: (status: SubmissionStatus) => {},
  handleCloseSnackbar: () => {},
});

export interface SubmissionStatus {
  display: boolean;
  message: string;
  severity?: "success" | "error";
}

type ToastProviderType = {
  children: ReactNode;
};

const ToastProvider: FC<ToastProviderType> = ({ children }) => {
  const [submissionStatus, setSubmissionStatus] = useState<SubmissionStatus>({
    display: false,
    message: "",
  });

  const addSnack = useCallback(
    (status: SubmissionStatus) => {
      setSubmissionStatus({ ...status });
    },
    [setSubmissionStatus]
  );

  const handleCloseSnackbar = useCallback(() => {
    setSubmissionStatus({ ...submissionStatus, display: false });
  }, [submissionStatus, setSubmissionStatus]);

  const providerValue = useMemo(
    () => ({ addSnack, handleCloseSnackbar }),
    [addSnack, handleCloseSnackbar]
  );

  return (
    <ToastContext.Provider value={providerValue}>
      <Snackbar
        open={submissionStatus.display}
        autoHideDuration={11000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={submissionStatus.severity}
          sx={{ width: "100%" }}
        >
          {submissionStatus.message}
        </Alert>
      </Snackbar>
      {children}
    </ToastContext.Provider>
  );
};

export default ToastProvider;
